<template>
  <div
    class="gender-icon"
    :class="{
      'male-icon-color': gender === 'MALE',
      'female-icon-color': gender === 'FEMALE'
    }"
  >
    <el-tooltip :content="tooltipText">
      <i :class="genderIcon" />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'GenderIcon',
  props: {
    gender: {
      type: String,
      default: ''
    }
  },
  computed: {
    tooltipText() {
      return this.gender ? this.$options.filters.ucwords(this.gender) : 'N/A'
    },

    genderIcon() {
      if (this.gender === 'MALE') {
        return 'el-icon-male'
      }
      else if (this.gender === 'FEMALE') {
        return 'el-icon-female'
      }
      else {
        return 'el-icon-remove-outline'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .gender-icon {
    font-size: 24px;
    text-align: center;
  }

  .male-icon-color {
    color: #36a3f7;
  }

  .female-icon-color {
    color: #f4516c;
  }
</style>
